import API_CONFIG from '../config';

const AGTFoundService = {
  async search(query, { uid, token, language } = {}) {
    try {
      if (!query?.trim()) {
        throw new Error('Query is required');
      }

      // Obtener el idioma actual del usuario
      let userLanguage = language || 'auto';
      
      // Si el idioma es 'auto', usar el idioma detectado del navegador
      if (userLanguage === 'auto') {
        userLanguage = navigator.language || 'en';
      }
      
      // Obtener solo el código base del idioma (ej: 'es' de 'es-419')
      const baseLanguage = userLanguage.split('-')[0];

      console.log('[AGTFoundService] Searching with language:', baseLanguage);

      const response = await API_CONFIG.createAxiosInstance().post('/found/search', {
        query,
        uid,
        language: baseLanguage
      });

      if (!response.data.success) {
        throw new Error(response.data.error || 'Error en la búsqueda');
      }

      return response.data;

    } catch (error) {
      console.error('Error en AGTFoundService:', error);
      if (error.response?.status === 500) {
        return {
          success: false,
          error: 'Error interno del servidor',
          recommendations: []
        };
      }
      throw error;
    }
  }
};

export default AGTFoundService;